module.exports = __webpack_public_path__ + "img/loggia.e4157d40.jpg";